module.exports = __webpack_public_path__ + "img/5.87a60d64.jpg";